import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useForm } from "react-hook-form";
import "./EditModal.css";
import { putData } from "../../../../Services/Api";
// import { GiPoland } from "react-icons/gi";

export default function EditModal({ plan, onClose, token, updatePlan }) {
  const [error, setError] = useState("");

  const {
    register,
    handleSubmit,
    // watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      title: plan.title,
      name: plan.name,
      dataLimit: plan.data_step_gb,
      saleText: plan.sale_text,
      priceInitial: plan.price_initial,
      pricePerData: plan.price_per_data,
      pricePercentageOff: plan.price_percentage_off,
      dataMinGb: plan.data_min_gb,
      dataMaxGb: plan.data_max_gb,
    },
  });

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const onSubmit = async (data) => {
    console.log(data, "datatt");
    const sendData = {
      id: plan?.id,
      title: data?.title || "",
      name: data?.name || "",
      sale_text: data?.saleText || null,
      price_initial: data?.priceInitial || 0,
      price_per_data: data?.pricePerData || 0,
      price_percentage_off: data?.pricePercentageOff || 0,
      data_min_gb: data?.dataMinGb || 0,
      data_max_gb: data?.dataMaxGb || 0,
      data_step_gb: data?.dataLimit || 0,
      status: 1,
    };

    const getDataResponse = await putData(
      "update-pricing-plan-details",
      sendData,
      headers
    );
    if (getDataResponse.success) {
      updatePlan();
      onClose();
    } else {
      setError(getDataResponse?.message);
    }
  };

  return (
    <Modal show={true} centered size="lg" onHide={onClose}>
      <Modal.Header className="px-4" closeButton>
        <Modal.Title>Edit Subscription Plan</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formSubscription">
                <Form.Label className="fw-medium">
                  Subscription Plan Title
                </Form.Label>
                <Form.Select
                  className="customFormTextAdmin rounded-5"
                  {...register("title", {
                    required: "Subscription Plan title is required",
                  })}
                  disabled
                >
                  <option value="Basic">Basic</option>
                  <option value="Plus">Plus</option>
                  <option value="Prime">Prime</option>
                  <option value="Pro">Pro</option>
                </Form.Select>
                {errors.title && (
                  <span className="text-danger">{errors.title.message}</span>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formnName">
                <Form.Label className="fw-medium">
                  Edit Subscription Name
                </Form.Label>
                <Form.Control
                  type="text"
                  className="customFormTextAdmin rounded-5"
                  placeholder="Enter Name"
                  {...register("name", {
                    required: "Subscription Name is required",
                  })}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formPriceInitial">
                <Form.Label className="fw-medium">Initial Price ($)</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  className="customFormTextAdmin rounded-5"
                  placeholder="Enter Initial Price"
                  {...register("priceInitial", {
                    required: "Initial Price is required",
                  })}
                />
                {errors.priceInitial && (
                  <span className="text-danger">
                    {errors.priceInitial.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formPricePerData">
                <Form.Label className="fw-medium">
                  Price Per Data ($)
                </Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  className="customFormTextAdmin rounded-5"
                  placeholder="Enter Price Per Data"
                  {...register("pricePerData", {
                    required: "Price Per Data is required",
                  })}
                />
                {errors.pricePerData && (
                  <span className="text-danger">
                    {errors.pricePerData.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formDataMinGb">
                <Form.Label className="fw-medium">Data Min (GB)</Form.Label>
                <Form.Control
                  type="number"
                  className="customFormTextAdmin rounded-5"
                  placeholder="Enter Data Min (GB)"
                  {...register("dataMinGb", {
                    required: "Data Min is required",
                  })}
                />
                {errors.dataMinGb && (
                  <span className="text-danger">
                    {errors.dataMinGb.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formDataMaxGb">
                <Form.Label className="fw-medium">Data Max (GB)</Form.Label>
                <Form.Control
                  type="number"
                  className="customFormTextAdmin rounded-5"
                  placeholder="Enter Data Max (GB)"
                  {...register("dataMaxGb")}
                />
                {errors.dataMaxGb && (
                  <span className="text-danger">
                    {errors.dataMaxGb.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formDataLimit">
                <Form.Label className="fw-medium">
                  Data Step Limit (GB)
                </Form.Label>
                <Form.Control
                  type="number"
                  className="customFormTextAdmin rounded-5"
                  placeholder="Enter Data Step Limit (GB)"
                  {...register("dataLimit", {
                    required: "Data Limit is required",
                  })}
                />
                {errors.dataLimit && (
                  <span className="text-danger">
                    {errors.dataLimit.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formPricePercentageOff">
                <Form.Label className="fw-medium">
                  Price Percentage Off (%)
                </Form.Label>
                <Form.Control
                  type="number"
                  className="customFormTextAdmin rounded-5"
                  placeholder="Enter Price Percentage Off"
                  {...register("pricePercentageOff", {
                    required: "Price Percentage Off is required",
                  })}
                />
                {errors.pricePercentageOff && (
                  <span className="text-danger">
                    {errors.pricePercentageOff.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formSaleText">
                <Form.Label className="fw-medium">Sale Text</Form.Label>
                <Form.Control
                  type="text"
                  className="customFormTextAdmin rounded-5"
                  placeholder="Enter Sale Text"
                  {...register("saleText")}
                />
              </Form.Group>
            </Col>
          </Row>
          {error && <div className="alert alert-danger">{error}</div>}
          <Modal.Footer className='d-flex justify-content-between'>
            <Button
              onClick={onClose}
              className="respoNavBtn btn btn-default bg-transparent border-1 border-black text-black rounded-5 pt-2 pb-2 px-3"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="respoNavBtn btn btn-default startedBtn border-1 border-success rounded-5 pt-2 pb-2 px-5"
            >
              Save
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
